import ReactModal from 'react-modal';
import { useAtom } from 'jotai';
import { AcctState } from 'stores/atoms/acctState';
import { getCompanyImageUrl } from 'utils/app';

import type { JSX } from 'react';

/**
 * カンパニー切り替えモーダル
 */
export default function WsModalCompanySwitch(props: {
  setOpen: (open: boolean) => void;
  open: boolean;
}): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 型定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const [acctState] = useAtom(AcctState);

  /* ----------------------------------------------------------------------- */
  /* ライフサイクル関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */
  /**
   * モーダルを閉じます。
   */
  const onClose = () => {
    props.setOpen(false);
  };

  /* ----------------------------------------------------------------------- */
  /* プライベート関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      <ReactModal
        isOpen={props.open}
        onRequestClose={onClose}
        style={{
          overlay: {
            zIndex: 2000,
            backgroundColor: 'rgba(30, 30, 30,0.5)',
          },
          content: {
            maxWidth: '600px',
          },
        }}
        className="ReactModal__Content__Custom"
        ariaHideApp={false}
      >
        <div className="modal-content rounded-4 switch-companies" style={{ maxWidth: 'none' }}>
          <div className="modal-header border-bottom-0">
            <button
              onClick={onClose}
              type="button"
              className="btn-close btn-circle-close"
              aria-label="Close"
            >
              <img src="/img/icon/multiply.svg" alt="x" />
            </button>
          </div>
          <div className="card card-detail">
            <div className="card-body">
              <h2 className="card-title text-start">カンパニーを切り替える</h2>

              <div className="button-group">
                {acctState.user.companies.map(item => {
                  return (
                    <a
                      key={item.id}
                      href={`/ws/${item.cd}`}
                      className="button-item d-flex justify-content-start align-items-center"
                    >
                      <span className="img-body">
                        <img
                          src={getCompanyImageUrl(item.imageKey)}
                          className="icon icon-business img-fluid"
                          alt={item.name}
                        />
                      </span>
                      <span className="name">{item.name}</span>
                    </a>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
    </>
  );
}
